import axiosBlobInstance from './axiosBlobInstance';
import {
  PlatformStatisticsQueryParamsDto,
  StatsPerCityQueryParamsDto,
  StatsPerClinicsQueryParamsDto,
  StatsPerProfessionalsQueryParamsDto,
} from '@docbay/schemas';

/**
 * This API provides methods to download statistics in Excel format.
 */
export const StatisticsExportApi = {
  /**
   * Downloads the statistics per city in Excel format.
   *
   * @param params - The query parameters for downloading the statistics.
   */
  downloadPerCityExcelStats: (params: StatsPerCityQueryParamsDto) =>
    axiosBlobInstance.post('/statistics/per-city/export', params),

  /**
   * Downloads the statistics per clinic in Excel format.
   *
   * @param params - The query parameters for downloading the statistics.
   */
  downloadPerClinicExcelStats: (params: StatsPerClinicsQueryParamsDto) =>
    axiosBlobInstance.post('/statistics/per-clinic/export', params),

  /**
   * Downloads the statistics per doctor in Excel format.
   *
   * @param params - The query parameters for downloading the statistics.
   */
  downloadPerDoctorExcelStats: (params: StatsPerProfessionalsQueryParamsDto) =>
    axiosBlobInstance.post('/statistics/per-professional/export', params),

  /**
   * Downloads the platform statistics in Excel format.
   */
  downloadPlatformExcelStats: (params: PlatformStatisticsQueryParamsDto) =>
    axiosBlobInstance.post('/statistics/platform/export'),

  /**
   * Downloads the specialization per city statistics in Excel format.
   *
   * @param params - The query parameters for downloading the statistics.
   */
  downloadSpecializationPerCityExcelStats: (
    params: PlatformStatisticsQueryParamsDto,
  ) =>
    axiosBlobInstance.post(
      '/statistics/per-city/specializations/export',
      params,
    ),
};
